import {Component} from '@angular/core';
import {VerbrauchsanalyseAusstiegComponent} from "../../verbrauchsanalyse/verbrauchsanalyse.ausstieg.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {ModeratRequestService} from "../services/request.service";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
  selector: 'app-verbrauchsanalyse-moderat-ausstieg',
  templateUrl: './../../verbrauchsanalyse/verbrauchsanalyse.ausstieg.component.html'
})
export class VerbrauchsanalyseModeratAusstiegComponent extends VerbrauchsanalyseAusstiegComponent {

  /**
   *
   */
  anfrage: ModeratAnfrage;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService, protected requestService: ModeratRequestService) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.anfrage = this.requestService.getAnfrage();
    this.textkeyPrefix = 'moderat';

    super.ngOnInit();
  }
}
